module.exports = __webpack_public_path__ + "static/img/no-audio.2ae87299.svg";